import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate"
const store = new Vuex.Store({
  state: {
    smElabelOrgInfo: {
      shPhone: '', // 手机号
      userId: '', // id
      userName: '', // 名称
      orgId: "", //机构==机构管理默认id
      orgName: "", //机构==机构管理默认name
      supperAuth: '', //超级管理员
      dutyYn: '',
    },
    smElabelOrgInfoToken: "", // 本地token
    orgAuth: [],
    userAuth: [],
  },
  mutations: {
    // 储存用户上一次登录手机号
    shPhone(state, data) {
      state.smElabelOrgInfo.shPhone = data;
    },
    userId(state, data) {
      state.smElabelOrgInfo.userId = data;
    },
    userName(state, data) {
      state.smElabelOrgInfo.userName = data;
    },
    orgId(state, data) {
      state.smElabelOrgInfo.orgId = data;
    },
    orgName(state, data) {
      state.smElabelOrgInfo.orgName = data;
    },
    supperAuth(state, data) {
      state.smElabelOrgInfo.supperAuth = data;
    },

    smElabelOrgInfoToken(state, data) {
      state.smElabelOrgInfoToken = data;
    },
    dutyYn(state, data) {
      state.smElabelOrgInfo.dutyYn = data;
    },
    orgAuth(state, data) {
      state.orgAuth = data;
    },
    userAuth(state, data) {
      state.userAuth = data;
    },
    dutySrvIp(state, data) {
      state.smElabelOrgInfo.dutySrvIp = data;
    },
    dutySrvUrl(state, data) {
      state.smElabelOrgInfo.dutySrvUrl = data;
    },
    org_level(state, data) {
      state.smElabelOrgInfo.org_level = data;
    },
  },
  plugins: [createPersistedState({
    key: 'smElabelOrgInfo'
  })]
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js